import { ErrorNotification } from '../../../services/error-notification';
import { DashboardApi, UserChart, UserService } from '../dashboard-api';
import { DashboardDetail } from './dashboard-detail';
import { DashboardDetailWidget } from './dashboard-detail-widget';

export interface DashboadWidgetSelectApp {
  loading: boolean;
  dashboardId: string;
  widgetId: string;
  type: 'APP' | 'CHART';
  serviceId: string | undefined;
  services: UserService[];
  charts: UserChart[];
}

export async function loadWidgetSelectApp(
  api: DashboardApi,
  dashboardId: string,
  widget: DashboardDetailWidget,
  update: (_: DashboadWidgetSelectApp | undefined) => void
): Promise<ErrorNotification | undefined> {
  const type = widget.serviceType === 'SUPERSET' ? 'CHART' : 'APP';
  const selectedService = widget.serviceId || undefined;

  update({ loading: true, dashboardId, widgetId: widget.id, type, serviceId: selectedService, services: [], charts: [] });

  const [services, charts] = await Promise.all([api.getUserServices(), api.getUserCharts()]);

  if (!services || !charts) {
    update(undefined);
    return { message: 'Error loading apps or charts.' };
  }

  update({ loading: false, dashboardId, widgetId: widget.id, type, serviceId: selectedService, services, charts });
}

export async function updateDashboardDetailWidgetService(
  widgetId: string,
  type: string,
  serviceId: string,
  api: DashboardApi,
  getModel: () => DashboardDetail,
  update: (_: DashboardDetail) => void
) {
  const model = getModel();
  const widget = model.widgets.find((w) => w.id === widgetId);
  if (!widget || !widget.selectApp) {
    return;
  }

  let updatedWidget: Pick<DashboardDetailWidget, 'name' | 'serviceId' | 'serviceType' | 'serviceName' | 'serviceStatus' | 'serviceUrl'>;

  if (type === 'APP') {
    const service = widget.selectApp.services.find((s) => s.id === serviceId);
    if (!service) {
      return;
    }
    updatedWidget = {
      name: null,
      serviceId,
      serviceName: service.name,
      serviceStatus: service.status,
      serviceUrl: service.url,
      serviceType: service.type === 'browser-app' ? 'MODULE' : 'SERVICE',
    };
  } else if (type === 'CHART') {
    const chart = widget.selectApp.charts.find((s) => s.id === serviceId);
    if (!chart) {
      return;
    }
    updatedWidget = {
      name: chart.name,
      serviceId,
      serviceName: null,
      serviceStatus: 'RUNNING',
      serviceUrl: chart.url,
      serviceType: 'SUPERSET',
    };
  } else {
    return;
  }

  update({
    ...model,
    widgets: model.widgets.map((w) => (w.id !== widgetId ? w : { ...w, ...updatedWidget, selectApp: undefined })),
  });

  const res = await api.updateWidget(model.id, widget.id, {
    name: updatedWidget.name,
    serviceId: updatedWidget.serviceId!,
    serviceType: updatedWidget.serviceType!,
  });

  if (!res?.ok) {
    return { message: 'Error updating widget app.' };
  }
}
